/**
 * @file The Orders lifecycle copy, keyed by `AnalyticsOrderLifecycle`: `name`
 * titles the lifecycle tile and `tag` is the line table's STATUS tag and the
 * filter part of its title ("Line items — HFR"). Consumers:
 * `AnalyticsOrderLifecycle`, `AnalyticsOrderLinesTable` and
 * `AnalyticsOrdersPanel`. The `Record` type fails the build when a lifecycle
 * is added without its copy.
 */
import type { AnalyticsOrderLifecycle } from './index.types';

export const ANALYTICS_ORDER_LIFECYCLE_LABELS: Record<
  AnalyticsOrderLifecycle,
  { name: string; tag: string }
> = {
  held: { name: 'Held for release', tag: 'HFR' },
  released: { name: 'Released', tag: 'Released' },
  shipped: { name: 'Shipped', tag: 'Shipped' },
};
